export default __webpack_public_path__ + "images/ada.png?02dd966b5f45cf9f458f6925d8013411";